
const createSimpleUpdateHandlers = (setter, extractor) => ({
  onMessageReceived: (data) => {
    const { message } = data;
    setter(extractor(message));
  },
  onOldMessagesReceived: (messages) => {
    if (messages && messages.length > 0) {
      const latestMessage = messages[messages.length - 1].message;
      setter(extractor(latestMessage));
    }
  },
});


export const createBannerUpdateHandlers = (setBannerName, setBannerId = null) => {
  const updateBannerIfChanged = (newBanner) => {
    const newMessage = newBanner?.message || '';
    const newId = newBanner?.BannerID || null;
    
    if (setBannerId) {
      setBannerName(newMessage);
      setBannerId(newId);
    } else {
      setBannerName(newMessage);
    }
  };

  return {
    onMessageReceived: (data) => {
      const { message } = data;
      updateBannerIfChanged(message);
    },
    onOldMessagesReceived: (messages) => {
      if (messages && messages.length > 0) {
        const latestMessage = messages[messages.length - 1].message;
        updateBannerIfChanged(latestMessage);
      }
    }
  };
};

export const createBackgroundUpdateHandlers = (setMeetingBackground) => 
  createSimpleUpdateHandlers(setMeetingBackground, (msg) => msg?.BackgroundUrl);


export const createOverlayUpdateHandlers = (setMeetingOverlay) => 
  createSimpleUpdateHandlers(setMeetingOverlay, (msg) => msg?.OverlayUrl);


export const createMusicUpdateHandlers = (audioRef) => {
  const handleMusicAction = (action, url) => {
    if (!audioRef.current) {
      audioRef.current = new Audio(url);
    }

    const audio = audioRef.current;

    if (action === "play" && url) {
      audio.src = url;
      audio.play();
    } else if (action === "pause") {
      audio.pause();
    }
  };

  return {
    onMessageReceived: (data) => {
      const { action, url } = data;
      handleMusicAction(action, url);
    },
    onOldMessagesReceived: (messages) => {
      if (messages && messages.length > 0) {
        const { action, url } = messages[messages.length - 1].data;
        handleMusicAction(action, url);
      }
    },
  };
};


export const createLogoUpdateHandlers = (setLogoPosition) => ({
  onMessageReceived: (data) => {
    const { message } = data;
    if (message.LogoAxisX || message.LogoAxisY) {
      setLogoPosition({ x: message.LogoAxisX, y: message.LogoAxisY });
    }
  },
  onOldMessagesReceived: (messages) => {
    if (messages && messages.length > 0) {
      const latestMessage = messages[messages.length - 1].message;
      if (latestMessage.LogoAxisX || latestMessage.LogoAxisY) {
        setLogoPosition({ x: latestMessage.LogoAxisX, y: latestMessage.LogoAxisY });
      }
    }
  },
});
